// extracted by mini-css-extract-plugin
module.exports = {"flatButton":"Upload_flatButton__1Olx9","flatButton_disabled":"Upload_flatButton_disabled__3COH8"};